import React from 'react';
import Header from '../../components/Header';
import FormLogin from '../../components/Form/loginForm';


function Login() {
  return (
    <div className="min-height">
      <Header titleHeader="Bienvenue" />
      <FormLogin />
    </div>
  );
}

export default Login;
